export const DISCORD_IMAGE_PRESETS = [
  { aspectRatio: "9:21", resolution: "576x1344", width: 576, height: 1344, label: "立绘" },
  { aspectRatio: "9:16", resolution: "720x1280", width: 720, height: 1280, label: "竖图" },
  { aspectRatio: "3:4", resolution: "720x960", width: 720, height: 960, label: "半身" },
  { aspectRatio: "1:1", resolution: "720x720", width: 720, height: 720, label: "封图" },
  { aspectRatio: "16:9", resolution: "1280x720", width: 1280, height: 720, label: "横图" },
] as const;

export type DiscordImagePreset = (typeof DISCORD_IMAGE_PRESETS)[number];
export type DiscordImageAspectRatio = DiscordImagePreset["aspectRatio"];

export function findDiscordImagePreset(value: unknown): DiscordImagePreset | undefined {
  if (typeof value !== "string") return undefined;
  return DISCORD_IMAGE_PRESETS.find(({ aspectRatio }) => aspectRatio === value);
}

export function findDiscordImagePresetByResolution(value: unknown): DiscordImagePreset | undefined {
  if (typeof value !== "string") return undefined;
  return DISCORD_IMAGE_PRESETS.find(({ resolution }) => resolution === value);
}
